import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';

import Dropzone from 'react-dropzone';
import filesize from 'filesize';

import { reduxForm } from "redux-form";

import { Icon, Image } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';
import { ModalTemplate, Button, Loading, ReduxFormMaterialSwitch } from 'components';

import * as validFunc from 'libs/validation';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalTargetExcelUpload extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      visible,
      isClicked,
      excelFileData,
      excelUploadResult,
      onToggleModal,
      onTargetExcelDownload,
      onTargetExcelDrop,
      onTargetExcelSubmit,
      onTargetExcelReset
    } = this.props;
    const isAcceptExcel = !!excelFileData && !!excelFileData.acceptFile.length;
    const isRejectExcel = !!excelFileData && !!excelFileData.rejectFile.length;

    // 업로드 성공
    // errInfo 처리 하깅

    let uploadResult;
    if (!!excelUploadResult['isUpload']) {
      const rd = excelUploadResult['resultData'];

      let editComponent;
      let errorComponent;
      let successComponent;

      // 등록 성공 시 해당 열과 대상자 이메일 표시
      if (rd['detailInfo']) {
        const detail = rd['detailInfo'];
        successComponent = (
          <div>
            <div>
              <div className={cx('errorDetail-title', 'brand')}>
                {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_34', defaultMessage: '성공 내역' }))}
              </div>
              <div className={cx('errorDetail-content', 'brand')}>
                {Object.keys(detail).map(key => {
                  return (
                    <div key={key} className={cx('error-info-row')}>
                      <div className={cx('error-info-title')}>
                        {key + defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_8', defaultMessage: '열' }))}
                      </div>
                      <div className={cx('error-info-content')}>{detail[key].targetEmail}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      }

      // 수정
      if (!!rd['editCount']) {
        const editresultDetail = [];
        let editRowName = '';

        for (const editRowNum in rd['editInfo']) {
          if (rd['editInfo'].hasOwnProperty(editRowNum)) {
            // 수정 내용
            const editContent = [];
            editRowName = rd['editInfo'][editRowNum];

            if (!!rd['editInfo']) {
              if (typeof editRowName.targetName !== 'undefined') {
                editContent.push(
                  defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_2', defaultMessage: '이름' }))
                );
              }
              if (typeof editRowName.targetPhone !== 'undefined') {
                editContent.push(
                  defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_4', defaultMessage: '연락처' }))
                );
              }
              if (typeof editRowName.targetDivision !== 'undefined') {
                editContent.push(
                  defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_5', defaultMessage: '소속' }))
                );
              }
              if (typeof editRowName.targetPosition !== 'undefined') {
                editContent.push(
                  defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_6', defaultMessage: '직급' }))
                );
              }
              if (typeof editRowName.tagName !== 'undefined') {
                const tagArray = [];
                //추가 된 태그 목록
                for (let i = 0; i < editRowName.tagName.length; i++) {
                  const eachTagName = editRowName.tagName[i].trim();
                  if (!!eachTagName) {
                    tagArray.push(eachTagName);
                  }
                }
                editContent.push(
                  defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_7', defaultMessage: '태그' })) +
                  '(' +
                  tagArray.join(', ') +
                  ')'
                );
              }

              editresultDetail.push(
                <div key={editRowNum} className={cx('error-info-row', 'text-color')}>
                  <div className={cx('error-info-title')}>
                    {editRowNum}
                    {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_8', defaultMessage: '열' }))}
                  </div>
                  <div className={cx('error-info-content')}>{editContent.join(', ')}</div>
                </div>
              );
            }
          }
        }
        editComponent = (
          <div>
            <div>
              <div className={cx('errorDetail-title', 'text-color')}>
                {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_30', defaultMessage: '수정 내용' }))}
              </div>
              <div className={cx('errorDetail-content', 'brand')}>{editresultDetail}</div>
            </div>
          </div>
        );
      }

      // 에러(실패)
      if (!!rd['errCount']) {
        const failresultDetail = [];
        let errRowName = '';
        for (const errorRowNum in rd['errInfo']) {
          if (rd['errInfo'].hasOwnProperty(errorRowNum)) {
            if (!!rd['errInfo'][errorRowNum]) {
              // 에러 사유
              const errorReason = [];
              errRowName = rd['errInfo'][errorRowNum];

              if (typeof errRowName.duplicated !== 'undefined') {
                errorReason.push(
                  <div key={errorRowNum}>
                    {defineMessages(
                      formatMessage({
                        id: 'ModalTargetExcelUpload_1',
                        defaultMessage: '이미 등록된 이메일이 존재합니다.'
                      })
                    )}
                  </div>
                );
              } else if (
                typeof errRowName.targetEmail !== 'undefined' &&
                typeof errRowName.targetName !== 'undefined'
              ) {
                errorReason.push(
                  <div key={errorRowNum}>
                    {defineMessages(
                      formatMessage({
                        id: 'ModalTargetExcelUpload_31',
                        defaultMessage: '필수 입력 값(이름/이메일)이 올바르지않습니다.'
                      })
                    )}
                  </div>
                );
              } else if (typeof errRowName.targetEmail !== 'undefined') {
                errorReason.push(
                  <div key={errorRowNum}>
                    {defineMessages(
                      formatMessage({ id: 'CtRegister_2', defaultMessage: '올바르지 않은 이메일 양식입니다.' })
                    )}
                  </div>
                );
              } else if (typeof errRowName.targetName !== 'undefined') {
                errorReason.push(
                  <div key={errorRowNum}>
                    {defineMessages(
                      formatMessage({
                        id: 'ModalTargetExcelUpload_32',
                        defaultMessage: '필수 입력 값(이름)이 올바르지않습니다.'
                      })
                    )}
                  </div>
                );
              } else if (typeof errRowName.targetPhone !== 'undefined') {
                errorReason.push(
                  <div key={errorRowNum}>
                    {defineMessages(
                      formatMessage({
                        id: 'ModalTargetExcelUpload_33',
                        defaultMessage: '올바르지 않은 연락처 양식입니다.'
                      })
                    )}
                  </div>
                );
              }

              failresultDetail.push(
                <div key={errorRowNum} className={cx('error-info-row')}>
                  <div className={cx('error-info-title')}>
                    {errorRowNum}
                    {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_8', defaultMessage: '열' }))}
                  </div>
                  <div className={cx('error-info-content')}>{errorReason}</div>
                </div>
              );
            }
          }
        }
        errorComponent = (
          <div>
            <div>
              <div className={cx('errorDetail-title')}>
                {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_11', defaultMessage: '실패 사유' }))}
              </div>
              <div className={cx('errorDetail-content')}>{failresultDetail}</div>
            </div>
          </div>
        );
      }

      if (excelUploadResult['isUpload'] === 1) {
        uploadResult = (
          <div className={cx('resuleMessage', 'success')}>
            <Icon name="check" />
            {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_12', defaultMessage: '업로드 성공' }))}
            <div className={cx('result-area')}>
              <div className={cx('count-text')}>
                {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_13', defaultMessage: '총 대상자' })) + ': '}
                {(!!rd['successCount'] ? rd['successCount'] : 0) +
                  (!!rd['editCount'] ? rd['editCount'] : 0) +
                  (!!rd['errCount'] ? rd['errCount'] : 0)}
                {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_10', defaultMessage: '명' }))}
              </div>
              {!!rd['successCount'] && (
                <div className={cx('count-text', 'brand')}>
                  {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_14', defaultMessage: '성공' })) + ': '}
                  {rd['successCount']}
                  {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_10', defaultMessage: '명' }))}
                </div>
              )}
              {!!rd['editCount'] && (
                <div className={cx('count-text', 'brand')}>
                  {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_29', defaultMessage: '수정' })) + ': '}
                  {rd['editCount']}
                  {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_10', defaultMessage: '명' }))}
                </div>
              )}
              {!!rd['errCount'] && (
                <div className={cx('count-text', 'color-red')}>
                  {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_9', defaultMessage: '실패' })) + ': '}
                  {rd['errCount']}
                  {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_10', defaultMessage: '명' }))}
                </div>
              )}
              {!!rd['detailInfo'] && successComponent}
              {!!rd['editCount'] && editComponent}
              {!!rd['errCount'] && errorComponent}
            </div>
          </div>
        );
        // 업로드 실패
      } else if (excelUploadResult['isUpload'] === 2) {
        uploadResult = (
          <div className={cx('resuleMessage', 'fail')}>
            <Icon name="x" />
            {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_15', defaultMessage: '업로드 실패' }))}
            <div className={cx('result-area')}>
              <div className={cx('count-text')}>
                {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_13', defaultMessage: '총 대상자' })) +
                  ': ' +
                  rd['errCount'] +
                  defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_10', defaultMessage: '명' }))}
              </div>
              {errorComponent}
            </div>
          </div>
        );

        // 업로드 에러
      } else if (excelUploadResult['isUpload'] === 3) {
        uploadResult = (
          <div className={cx('resuleMessage', 'fail')}>
            <div>
              <Icon name="x" />
              {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_16', defaultMessage: '서버 에러 발생' }))}
            </div>
            <div>
              {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_17', defaultMessage: '다시 시도 하세요' }))}
            </div>
          </div>
        );

        // 대상자 1000명 이상 업로드
      } else if (excelUploadResult['isUpload'] === 4) {
        uploadResult = (
          <div className={cx('resuleMessage', 'fail')}>
            <div>
              <Icon name="x" />
              {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_15', defaultMessage: '업로드 실패' }))}
            </div>
            <div>{!!rd['errInfo'] && rd['errInfo']}</div>
          </div>
        );
      }
    }

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-targetExcelUpload-area', 'common-content')}
        visible={visible}
        onToggleModal={onToggleModal}
        header={defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_18', defaultMessage: '대상자 일괄 등록' }))}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_20', defaultMessage: '닫 기' }))}
            </Button>
            <Button
              className={cx('brand-button')}
              disabled={isClicked || excelUploadResult.isUpload !== 0}
              loading={isClicked}
              onClick={onTargetExcelSubmit}>
              {defineMessages(formatMessage({ id: 'ModalTargetExcelUpload_19', defaultMessage: '업로드' }))}
            </Button>
          </div>
        }>
        <div className={cx('modal-content')}>
          <Loading active={isClicked} size="small" content="Waiting..." />
          <div className={cx('upload-wrapper')}>
            <div>
              <div className={cx('guide-text', 'message-header')}>
                {defineMessages(
                  formatMessage({
                    id: 'ModalTargetExcelUpload_21',
                    defaultMessage: '엑셀양식으로 한번에 여러 대상자를 추가합니다.'
                  })
                )}
              </div>
            </div>
            <div className={cx('bt-download-area')}>
              <Button
                className={cx('bt-style-gleam')}
                buttonColor="#333333"
                size="tiny"
                onClick={onTargetExcelDownload}>
                <Image src="/img/modal/downLoad.png" />
                {/* <Icon name="file excel outline" /> */}
                {defineMessages(
                  formatMessage({ id: 'ModalTargetExcelUpload_22', defaultMessage: '엑셀양식 다운로드' })
                )}
              </Button>
            </div>
            <div className={cx("input-area-mt")}>
              <ReduxFormMaterialSwitch
                className={cx("input-switch")}
                label={defineMessages(
                  formatMessage({
                    id: "ModalTargetAdd_12",
                    defaultMessage: "기존에 삭제된 대상자 재등록",
                  })
                )}
                name="isResurrection"
                checkType={101}
              />
            </div>
            <div
              className={cx(
                'dropzone flex-column',
                {
                  acceptDrop: isAcceptExcel
                },
                {
                  rejectDrop: isRejectExcel
                }
              )}>
              <Dropzone
                onDrop={onTargetExcelDrop}
                activeClassName="activeDrop"
                title={defineMessages(
                  formatMessage({ id: 'ModalTargetExcelUpload_23', defaultMessage: '클릭하여 파일을 선택하세요.' })
                )}>
                {({ isDragActive }) => {
                  const isActiveMessage = isDragActive && (
                    <div className={cx('isDragActive-guide')}>
                      {defineMessages(
                        formatMessage({
                          id: 'ModalTargetExcelUpload_24',
                          defaultMessage: '파일을 끌어 놓아서 추가 할 수 있습니다.'
                        })
                      )}
                    </div>
                  );

                  // 정상적인 템플릿 파일을 등록
                  if (isAcceptExcel) {
                    return excelFileData.acceptFile.map(f => (
                      <div className={cx('uploadFile-area')} key={f.name}>
                        {isActiveMessage}
                        <div className={cx('acceptFile')}>
                          <div className={cx('excelIcon')} />
                          <div className={cx('excelFile-info')}>
                            <div className={cx('file-name')}>{f.name}</div>
                            <div className={cx('file-size')}>{filesize(f.size)}</div>
                          </div>
                          <Tooltip
                            title={defineMessages(
                              formatMessage({ id: 'ModalTargetExcelUpload_25', defaultMessage: '업로드 파일 삭제' })
                            )}
                            placement="right">
                            <Icon
                              name="trash"
                              className={cx('bt-resetFile')}
                              onClick={e => {
                                e.stopPropagation();

                                onTargetExcelReset();
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    ));
                    // 템플릿이 아닌 다른 파일을 올린 경우
                  } else if (isRejectExcel) {
                    return excelFileData.rejectFile.map(f => (
                      <div className={cx('uploadFile-area')} key={f.name}>
                        {isActiveMessage}
                        <div className={cx('rejectFile')}>
                          <div>
                            <span className={cx('rejectFile-name')}>'{f.name}'</span>
                            {defineMessages(
                              formatMessage({
                                id: 'ModalTargetExcelUpload_26',
                                defaultMessage: '은 대상자 일괄 등록 엑셀 양식이 아닙니다.'
                              })
                            )}
                          </div>
                          <div className={cx('info-text')}>
                            <Icon name="info circle" />
                            {ReactHtmlParser(
                              defineMessages(
                                formatMessage({
                                  id: 'ModalTargetExcelUpload_27',
                                  defaultMessage: "<b>'엑셀양식 다운로드'</b>로 작성한 파일만 등록이 가능합니다."
                                })
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    ));
                  } else {
                    // 파일 올리기 전
                    return (
                      <div className={cx('upload-guide')}>
                        {isDragActive && (
                          <div className={cx('isDragActive-guide')}>
                            {defineMessages(
                              formatMessage({
                                id: 'ModalTargetExcelUpload_24',
                                defaultMessage: '파일을 끌어 놓아서 추가 할 수 있습니다.'
                              })
                            )}
                          </div>
                        )}
                        {/* <Icon name="cloud upload" size="large" /> */}
                        <Image src="/img/modal/upload.png" />
                        <span>
                          {defineMessages(
                            formatMessage({
                              id: 'ModalTargetExcelUpload_28',
                              defaultMessage: 'Excel 파일을 끌어 놓거나, 클릭하기'
                            })
                          )}
                        </span>
                      </div>
                    );
                  }
                }}
              </Dropzone>
            </div>
            {/* 업로드 결과 */}

            {!!excelUploadResult['isUpload'] && <div className={cx('upload-result-area')}>{uploadResult}</div>}
          </div>
        </div>
      </ModalTemplate>
    );
  }
}

ModalTargetExcelUpload.propTypes = {
  visible: PropTypes.bool,
  onToggleModal: PropTypes.func
};

export default reduxForm({
  form: "formTargetUpload",
  enableReinitialize: true,
})(injectIntl(ModalTargetExcelUpload));



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalTargetExcelUpload.js